import { ISalesperson } from '@/Interfaces';
import { IValidator, Validations } from '@samc/centricity-core';
import { validateEmail, validateAlphaNumeric } from './ValidateFunctions';

export class SalespersonValidator implements IValidator<ISalesperson> {
  public isValid(value: ISalesperson): Validations<ISalesperson> {
    const validations: Validations<ISalesperson> = {};
    
    if (value.lastName.length === 0) validations.lastName = 'Last Name is required!';
    if (value.firstName.length === 0) validations.firstName = 'First Name is required!';
    if (value.salespersonId.length === 0) validations.salespersonId = 'Salesperson ID is required!';
    if (value.salespersonId.length > 20) validations.salespersonId = 'Salesperson ID length can have maximum 20 characters!';
    if (value.salespersonId.length > 0 && !validateAlphaNumeric(value.salespersonId)) validations.salespersonId = 'Salesperson ID should contain only letters and numbers!';
    if (value.email?.length > 0 && !validateEmail(value.email)) validations.email = 'Email has invalid email address!';

    return validations;
  }
}
